import { useTranslation } from 'i18n'
import {
  ACTIVITIES_PATH,
  ACTIVITIES_V3_PATH,
  ADMIN_SUMMARY_REPORT_V3_PATH,
  BIBLION_PANEL_PATH,
  COMUNICAR_STORY_TREE_HOME_ROOT_PATH,
  FOREST_PATH,
  JOURNEY_HOME_ROOT_PATH,
  LEAGUE_PATH,
  LER_NEWSSTAND_ROOT_PATH,
  MY_READINGS_MODULAR_PATH,
  RECOMMENDATIONS_PATH,
  ROOT_PATH,
  RUNNING_RECORDS_APP_V2_PATH,
  SEED_PANEL_PATH,
  STORY_TREE_PATH
} from 'routes/paths'
import type { MenuItemType } from './HeaderDesktop.types'
import useFeatureToggles from 'utils/hooks/use-feature-toggles'
import { useUserInfo } from 'utils/hooks/use-userInfo'
import { useQuery } from '@tanstack/react-query'
import { journeysControllerGetMyJourney } from 'api.gen'

export function useHeader() {
  const { t } = useTranslation()
  const { user } = useUserInfo()
  const { featureToggles } = useFeatureToggles()
  const canAccessStoryTree = user?.featureToggles?.storyTree

  const { error } = useQuery({
    queryKey: ['myJourney'],
    queryFn: () => journeysControllerGetMyJourney(),
    retry: 0,
    enabled: Boolean(user?.id && canAccessStoryTree)
  })

  const journeyNotFound = error?.message?.includes('Journey not found')

  const homeTab: MenuItemType = {
    id: 0,
    label: t('Início'),
    iconName: 'home',
    iconNameActive: 'home-filled',
    hotjarEventName: 'menu_inicio',
    pathToGo: ROOT_PATH
  }

  const homeStoryTreeTab: MenuItemType = {
    id: 0,
    label: t('Início'),
    iconName: 'home',
    iconNameActive: 'home-filled',
    hotjarEventName: 'menu_inicio',
    pathToGo: STORY_TREE_PATH
  }

  const storyTreeComunicarTab: MenuItemType = {
    id: 8,
    label: t('Biblioteca'),
    iconName: 'journal',
    iconNameActive: 'journal',
    hotjarEventName: 'menu_biblioteca',
    pathToGo: COMUNICAR_STORY_TREE_HOME_ROOT_PATH
  }

  const myReadingsTab: MenuItemType = {
    id: 1,
    label: t('Minhas leituras'),
    iconName: 'book-person',
    iconNameActive: 'book-person-filled',
    hotjarEventName: 'menu_meus_ebooks',
    pathToGo: MY_READINGS_MODULAR_PATH
  }

  const activitiesTab: MenuItemType = {
    id: 2,
    label: t('Tarefas'),
    iconName: 'clipboard-content',
    iconNameActive: 'clipboard-content-filled',
    hotjarEventName: 'menu_atividades',
    pathToGo: ACTIVITIES_PATH
  }

  const activitiesV3Tab: MenuItemType = {
    id: 2,
    label: t('Atividades'),
    iconName: 'clipboard-content',
    iconNameActive: 'clipboard-content-filled',
    hotjarEventName: 'menu_atividades',
    pathToGo: ACTIVITIES_V3_PATH
  }

  const recommendationsTab: MenuItemType = {
    id: 2,
    label: t('Atividades'),
    iconName: 'layout-grid-rearrange',
    iconNameActive: 'layout-grid-rearrange',
    hotjarEventName: 'menu_atividades',
    pathToGo: RECOMMENDATIONS_PATH
  }

  const forestTab: MenuItemType = {
    id: 3,
    label: t('Conquistas'),
    iconName: 'medal',
    iconNameActive: 'medal-filled',
    hotjarEventName: 'menu_conquistas',
    pathToGo: FOREST_PATH
  }

  const leagueTab: MenuItemType = {
    id: 4,
    label: t('Conquistas'),
    iconName: 'medal',
    iconNameActive: 'medal-filled',
    hotjarEventName: 'menu_conquistas',
    pathToGo: LEAGUE_PATH
  }

  const adminTab: MenuItemType = {
    id: 5,
    label: t('Painel do Educador'),
    iconName: 'graduation-cap',
    iconNameActive: 'graduation-cap-filled',
    hotjarEventName: 'menu_painel_educador',
    pathToGo: ADMIN_SUMMARY_REPORT_V3_PATH
  }

  const pressReaderTab: MenuItemType = {
    id: 6,
    label: t('Banca'),
    iconName: 'newspaper-alt',
    iconNameActive: 'newspaper-alt-filled',
    hotjarEventName: 'menu_banca',
    pathToGo: LER_NEWSSTAND_ROOT_PATH
  }

  const journeyTab: MenuItemType = {
    id: 9,
    label: 'Journey',
    iconName: 'leaf-outline',
    iconNameActive: 'leaf',
    hotjarEventName: 'menu_jornada',
    pathToGo: journeyNotFound
      ? RUNNING_RECORDS_APP_V2_PATH
      : JOURNEY_HOME_ROOT_PATH
  }

  const panelTab: MenuItemType = {
    id: 10,
    label: featureToggles?.biblionPanel ? t('Painel') : t('Painel do Educador'),
    iconName: featureToggles?.biblionPanel ? 'chart-pie' : 'graduation-cap',
    iconNameActive: featureToggles?.biblionPanel
      ? 'chart-pie'
      : 'graduation-cap-filled',
    hotjarEventName: 'menu_painel_biblion',
    pathToGo: featureToggles?.biblionPanel
      ? BIBLION_PANEL_PATH
      : SEED_PANEL_PATH
  }

  return {
    homeTab,
    adminTab,
    panelTab,
    forestTab,
    leagueTab,
    activitiesTab,
    activitiesV3Tab,
    recommendationsTab,
    myReadingsTab,
    pressReaderTab,
    journeyTab,
    storyTreeComunicarTab,
    homeStoryTreeTab
  }
}
